export enum WorkStatus {
    NONCORRECTED = "non-corrected",
    CORRECTED = "corrected",
    MESSAGE = "message",
}

export default WorkStatus;
